<template>
  <div>
    <el-card class="mtf-head">
      <el-row :gutter="20">
        <el-col v-loading="statisticsloading" :span="6">
          <div class="accumulatedL custom-flex-space-between" style="background: rgb(235, 253, 238)">
            <div class="justify-content">
              <div class="ocean-content">{{ $t('DomesticMarineTransportation.NumberOfTransactions') +':'+formData.jobCount }}</div>
            </div>
            <img src="@/assets/fms/1.png" style="width: 120px;height: 120px;margin-top: -20px;">
          </div>
        </el-col>
        <el-col v-loading="statisticsloading" :span="6">
          <div class="accumulatedL custom-flex-space-between" style="background: #ffefef">
            <div class="justify-content">
              <div class="ocean-content">{{ $t('DomesticMarineTransportation.QuantityofContainers')+':'+formData.teuSum +' (TEU)' }}</div>
            </div>
            <img src="@/assets/fms/2.png">
          </div>
        </el-col>
        <el-col v-loading="statisticsloading" :span="3">
          <div class="accumulatedR custom-flex border borderRadius">
            <div>
              <p class="label">{{ $t('DomesticMarineTransportation.Loaded') }}</p>
              <div class="custom-flex-space-between svg">
                <img src="@/assets/fms/transport_status_1.png">
                <p class="content">{{ formData.shipmentTotal }}</p>
              </div>
            </div>
          </div>
        </el-col>
        <el-col v-loading="statisticsloading" :span="3">
          <div class="accumulatedR custom-flex border borderRadius">
            <div>
              <p class="label">{{ $t('DomesticMarineTransportation.Sailed') }}</p>
              <div class="custom-flex-space-between svg">
                <img src="@/assets/fms/booking.png" class="svgimg">
                <p class="content">{{ formData.sailTotal }}</p>
              </div>
            </div>
          </div>
        </el-col>
        <el-col v-loading="statisticsloading" :span="3">
          <div class="accumulatedR custom-flex border borderRadius">
            <div>
              <p class="label">{{ $t('DomesticMarineTransportation.ArrivedatPort') }}</p>
              <div class="custom-flex-space-between svg">
                <img src="@/assets/fms/declared.svg" class="svgimg">
                <p class="content">{{ formData.arrivalTotal }}</p>
              </div>
            </div>
          </div>
        </el-col>
        <el-col v-loading="statisticsloading" :span="3">
          <div class="accumulatedR custom-flex border borderRadius">
            <div>
              <p class="label">{{ $t('DomesticMarineTransportation.Delivered') }}</p>
              <div class="custom-flex-space-between svg">
                <img src="@/assets/fms/sail.svg" class="svgimg">
                <p class="content">{{ formData.deliverTotal }}</p>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </el-card>
    <el-row :gutter="10">
      <el-col :span="24">
        <el-card v-loading="businessloading" class="mt10 minheight350">
          <span class="fw600">{{ $t('DomesticMarineTransportation.BusinessStatistics') }}</span>
          <div class="custom-flex-space-between mt16">
            <div class="customblue border borderRadius dian custom-flex-center">{{ $t('DomesticMarineTransportation.DestinationPortNumberofShipments') }}</div>
            <!-- <el-date-picker v-model="businessPickerTime" class="custom-input" type="month" format="yyyy-MM" value-format="yyyyMM" :clearable="false" placeholder="月度" size="small" @change="businessChange" /> -->
          </div>
          <BarChart
            id="businessBar"
            ref="businessBar"
            left="2%"
            :yAxisMinInterval="1"
          />
        </el-card>
      </el-col>
      <el-col :span="24">
        <el-card v-loading="cbmloading" class="mt10 minheight350">
          <span class="fw600">{{ $t('DomesticMarineTransportation.ContainerStatistics') }}</span>
          <div class="custom-flex-space-between mt16">
            <div class="customblue border borderRadius dian custom-flex-center">{{ $t('DomesticMarineTransportation.DestinationPortQuantityofContainers') }}</div>
            <!-- <el-date-picker v-model="volumePickerTime" class="custom-input" type="month" format="yyyy-MM" value-format="yyyyMM" :clearable="false" placeholder="月度" size="small" @change="volumeChange" /> -->
          </div>
          <BarChart
            id="volumeBar"
            ref="volumeBar"
            left="2%"
          />
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { getDataStatistics, getBusinessStatisticsTotal, getTEUStatisticsTotal } from '@/api/ocean/order/mm/index'
import BarChart from '@/components/fms/barChart/index.vue'
import { FormatDate } from '@/utils/isClass'
export default {
  components: { BarChart },
  props: {
    timeDimension: {
      type: String,
      default: '1'
    },
    customerCode: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      formData: {},
      businessPickerTime: FormatDate(new Date()),
      volumePickerTime: FormatDate(new Date()),
      statisticsloading: false,
      businessloading: false,
      cbmloading: false
    }
  },
  computed: {},
  watch: {
    timeDimension(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.getDataStatistics()
        this.getBusinessTotal()
        this.getTEUTotal()
      }
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.getList()
    },
    getList() {
      this.getDataStatistics()
      this.getBusinessTotal()
      this.getTEUTotal()
    },
    /** 查询业务数量 */
    async getDataStatistics() {
      this.statisticsloading = true
      const params = { TimeDimension: this.timeDimension, CustomerCode: this.customerCode }
      var res = await getDataStatistics(params)
      if (res && res.isSuccess) {
        var data = res.data
        this.formData = data
      } else {
        this.messagebox.alert(this.$t('DomesticMarineTransportation.SearchErr'))
      }
      this.statisticsloading = false
    },
    /** 查询业务统计 */
    async getBusinessTotal() {
      this.businessloading = true
      const params = { TimeDimension: this.timeDimension, CustomerCode: this.customerCode }
      var res = await getBusinessStatisticsTotal(params)
      if (res && res.isSuccess) {
        var data = res.data
        // 按数量排序
        data = data.sort((a, b) => b.count - a.count)
        // 取前10条数据 10条后的汇总为其他
        const top10Data = data.slice(0, 10)
        const totalCount = data.slice(10).reduce((sum, item) => sum + item.count, 0)
        var dataName = top10Data.map(item => this.$ls.get('lang') === 'zh' ? item.podName : item.podNameEn)
        var dataSource = top10Data.map(item => item.count)
        if (totalCount > 0) {
          dataName.push(this.$t('DomesticMarineTransportation.Others'))
          dataSource.push(totalCount)
        }
        this.$refs.businessBar.chartInit(dataName, dataSource)
      } else {
        this.messagebox.alert(this.$t('DomesticMarineTransportation.SearchErr'))
      }
      this.businessloading = false
    },
    /** 查询 箱量统计 */
    async getTEUTotal() {
      this.cbmloading = true
      const params = { TimeDimension: this.timeDimension, CustomerCode: this.customerCode }
      var res = await getTEUStatisticsTotal(params)
      if (res && res.isSuccess) {
        var data = res.data
        // 按数量排序
        data = data.sort((a, b) => b.count - a.count)
        // 取前10条数据 10条后的汇总为其他
        const top10Data = data.slice(0, 10)
        const totalCount = data.slice(10).reduce((sum, item) => sum + item.count, 0)
        var dataName = top10Data.map(item => this.$ls.get('lang') === 'zh' ? item.podName : item.podNameEn)
        var dataSource = top10Data.map(item => item.count)
        if (totalCount > 0) {
          dataName.push(this.$t('DomesticMarineTransportation.Others'))
          dataSource.push(totalCount)
        }
        this.$refs.volumeBar.chartInit(dataName, dataSource)
      } else {
        this.messagebox.alert(this.$t('DomesticMarineTransportation.SearchErr'))
      }
      this.cbmloading = false
    },
    /** 业务统计时间选择时间 */
    businessChange() {
      this.getBusinessTotal()
    },
    /**  箱量统计选择时间 */
    volumeChange() {
      this.getTEUTotal()
    }
  }
}
</script>
<style scoped>
/* 公共样式提取至内部 开始*/
.custom-input {
  border: none;
  width: 200px;
}
.custom-input >>> input {
  border: none;
  background: #f6f6f8;
}
/* 公共样式提取至内部 结束 */

.mtf1 {
  margin-top: -1px;
  border-top: #fff;
}
.mtf-head {
  margin-top: -1px;
  border-top: #fff;
}
.mtf-head >>> .el-card__body {
  padding: 0px 20px 20px 20px !important;
}

.mt10 {
  margin-top: 10px;
}
.mt16 {
  margin-top: 16px;
}
.fw600 {
  font-weight: 600;
}
.minheight350 {
  min-height: 350px;
}
.border {
  border: 1px solid #e5e7eb;
}
.borderRadius {
  border-radius: 10px;
}
.dian::before {
  content: '';
  display: inline-block;
  width: 5px;
  height: 5px;
  background: #58c6e4;
  border-radius: 50%;
  margin-right: 6px;
  margin-bottom: 2px;
}
.curMonth {
  padding: 10px 4px;
  background: #f6f6f8;
}
.elSelect {
  width: 180px;
  margin-left: 10px;
  border-radius: 8px;
}
.accumulatedL,
.accumulatedR {
  padding: 16px 24px;
  height: 88px;
}
.accumulatedL .label,
.accumulatedR .label {
  font-size: 12px;
  font-weight: 400;
  color: #4b5563;
}
.accumulatedL .content {
  font-size: 26px;
  font-weight: 600;
  color: #111827;
  margin-top: 14px;
}
.accumulatedR .content {
  font-size: 26px;
  font-weight: 600;
  color: #111827;
  margin: 10px 0 0 8px;
}
.accumulatedL img {
  width: 64px;
  height: 64px;
  display: inline-block;
}
.accumulatedR img {
  width: 30px;
  height: 30px;
  display: inline-block;
  margin-top: 14px;
}
.ocean-label{
  font-size: 13px;
  font-weight: 400;
  color: #4b5563;
}
.ocean-content{
  font-size: 15px;
  font-weight: 600;
  color: #111827;
  margin: 8px 0 0 8px;
}
.svg{
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.svgimg{
  position: relative;
  left: -80px;
  filter: drop-shadow(#3809f3 80px 0);
}
.justify-content{
  display: flex !important;
  justify-content: center;
  align-items: center;
}
</style>
